import React from "react";
import MaterialTable from "material-table";
import { connect } from "react-redux";
import Axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import NotificationAlert from "react-notification-alert";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';

import { Button } from '@material-ui/core';
import withStyles from "@material-ui/core/styles/withStyles";
import { API_CONFIG } from "./../../../config/config.jsx";
import CreateUser from './CreateUsers.jsx';

const style = (theme) => ({
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  imgStyle: {
    width: 35,
    height: 35,
    cursor: "pointer",
  },
  fileStyle: {
    width: "130px",
  },
  pStyle: {
    // marginTop: "20px",
  },
});

export class Users extends React.Component {
  constructor() {
    super();
    this.state = {
      usersData: [],
      isCreateUser:false,
      isLoading:false,
      userData: {}
    };
  }
  componentDidMount() {
    console.log(this.props);
    this.getUsers();
  }
  getUsers = () => {
    this.setState({ isLoading: true });
    const token = sessionStorage.getItem("plugoAuthKey");
    const userId = sessionStorage.getItem("plugoUserId");
    Axios.get(`${API_CONFIG.HOST}/user`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-USER-ID": userId,
      },
    })
      .then((res) => {
        console.log("API RES",res.data);
        this.setState({
          isLoading: false,
          usersData: res.data,
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        const options = {
          place: "tc",
          message: `  ${
            error.response
              ? error.response.data.message
              : "Something went wrong"
          }`,
          type: "danger",
          icon: "fas fa-exclamation-triangle",
          autoDismiss: 4,
        };
        if (this.notification && this.notification.state.notifyTR.length < 1) {
          this.notification.notificationAlert(options);
        }
      });
  };
  handleIsCreateUser = () =>{
    this.setState({
      isCreateUser:false
    })
    this.getUsers();
  }
  render() {
    return (
      <div>
        <br />
        <div className="rna-container">
          <NotificationAlert
            ref={(c) => {
              this.notification = c;
            }}
          />
        </div>
      {this.state.isLoading ? (
    
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <CircularProgress />
        </div>
      
       ) :(
        !this.state.isCreateUser ? (<React.Fragment>
          <div style={{ marginBottom: "20px",  }}>
          <Button
            startIcon={<AddCircleIcon fontSize="medium" />}
            onClick={() => {
              this.setState({isCreateUser:true})
            }}
            disabled={this.state.isButtonDisabled}
            variant="contained"
            color="primary"
          >
            Add User
          </Button>
        </div>
          <MaterialTable
          title="Users"
          columns={[
            // {title: "View Boxes",field: "id",render : rowData => ( <Tooltip title="Click to see boxes" placement="top">
            //                  <a onClick={() => this.openBoxDialog(rowData.id, rowData.name)}>
            //                   <img
            //                       src={boxicon}
            //                       style={{ width: "35px", height: "35px" }}
            //                     />
            //                   </a>
            //                 </Tooltip>
            //               )
            //             },
            { title: "Name", field: "user.username" },
            // { title: 'Address', field: 'address', render: rowData =><span>{rowData.address} <a onClick={() => this.handleOpenEditDialog(rowData)} style={{ cursor: "pointer", color: "blue" }} >Edit</a></span> },
           // { title: "Country", field: "user.country.name" },
            { title: "Mobile", field: "user.mobile" },
            { title: "User Type", field: "userType" },
            { title: "BUID", field: "user.buid" },
            { title: "Edit", render: rowData =><span><a 
            onClick={() => {
              console.log('onclick user', rowData);
              this.setState({isCreateUser:true, userData: rowData.user})
            }}
            style={{ cursor: "pointer", color: "blue" }} >
              <Button variant="outlined" startIcon={<EditIcon fontSize="small" />} >
            </Button></a></span> },

            // { title: 'Visible', field: 'isVisible', type: 'boolean', render: rowData => <Switch checked={rowData.isVisible} onChange={this.onChangeVisible} color="primary" /> },
            // { title: 'Review Applicable', field: 'reviewApplicable', type: 'boolean', render: rowData => <Checkbox checked={rowData.reviewApplicable} onChange={this.onReviewApplicableChange} color="primary" /> },
            // { title: 'Update Operating Hours', field: 'operatingHour', render: rowData => Secure("CREATE_STORE_OPERATING_HOURS", <img onClick={() => this.handleOpen(rowData.id)} className={classes.imgStyle} src={OpertingHourIcon}></img>) },
            // { title: 'Upload Image', field: 'uploadImage', render: rowData => Secure("UPLOAD_S3", <a onClick={() => this.handleOpenUploadDialog(rowData.id)} style={{ cursor: "pointer", color: "blue" }} >Upload</a>) }
          ]}
          data={this.state.usersData}
        />

        
        </React.Fragment>) : (
        <CreateUser handleCancel={this.handleIsCreateUser} userData={this.state.userData} />
        )
        )}
       
      </div>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    users: state.users.usersData,
    resMessage: state.users.resMessage,
    resStatus: state.users.resStatus,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(style)(Users));
